import { Injectable } from '@angular/core';
import { MenuItem } from 'src/app/dto/MenuItem';
import { LoginService } from 'src/app/login/login.service';
import { Accion } from 'src/app/modals/solicitudes/acciones/acciones.enum';

/**
 * BreadcrumMenuService
 *
 * @export
 * @class BreadcrumMenuService
 */
@Injectable({
  providedIn: 'root'
})
export class BreadcrumMenuService {
  public actual: number = 1;
  private _esEmpresa: boolean = false;
  public esEmpresaConsulta: boolean = false;
  private _esAESAN: boolean = false;
  private _esCartera: boolean = false;

  public get esEmpresa()  {return this._esEmpresa}
  public get esAESAN()  {return this._esAESAN}
  public get esCartera()  {return this._esCartera}

  public Header: any = null;

  home = { icon: 'pi pi-home', routerLink: '/ui/empresa' };
  migaPan = [
    { label: 'Gestión solicitudes', routerLink: '/ui/empresa/solicitudes', secciones: ['/ui/empresa/solicitudes', '/ui/empresa/consultasol', '/ui/empresa/inclusion', '/ui/empresa/alteracion', '/ui/empresa/alteracionempresa'] },
    { label: 'Detalle solicitud', secciones: ['/ui/empresa/consultasol', '/ui/empresa/inclusion', '/ui/empresa/alteracion', '/ui/empresa/alteracionempresa'] },
    { label: 'Comercialización', routerLink: '/ui/empresa/productos', secciones: ['/ui/empresa/productos', '/ui/empresa/detalleproducto'] },
    { label: 'Detalle producto', secciones: ['/ui/empresa/detalleproducto'] },
    { label: 'Tramitación firmas', routerLink: '/ui/firmas/listado', secciones: ['/ui/firmas/listado', '/ui/firmas/detallefirma'] },
    { label: 'Detalle firma', secciones: ['/ui/firmas/detallefirma'] },
    { label: 'Nomenclátor', routerLink: '/ui/nomenclator/publicaciones', secciones: ['/ui/nomenclator/publicaciones', '/ui/nomenclator/detalle'] },
    { label: 'Detalle nomenclátor', routerLink: '/ui/nomenclator/detalle', secciones: ['/ui/nomenclator/detalle'] },
    { label: 'Consumo', secciones: ['/ui/consumo/listado', '/ui/consumo/informe'], disabled: true },
    { label: 'Listado consumo', routerLink: '/ui/consumo/listado', secciones: ['/ui/consumo/listado'] },
    { label: 'Informe consumo', routerLink: '/ui/consumo/informe', secciones: ['/ui/consumo/informe'] },
    { label: 'Administrador', secciones: ['/ui/admin/usuarios', '/ui/admin/crearUsuario', '/ui/admin/infoUsuario', '/ui/admin/editarUsuario', '/ui/admin/perfiles', '/ui/admin/crearPerfil', '/ui/admin/infoPerfil', '/ui/admin/editarPerfil', '/ui/admin/parametros', '/ui/admin/producto/tipos', '/ui/admin/producto/tipos/afectadas'], disabled: true },
    { label: 'Usuarios', routerLink: '/ui/admin/usuarios', secciones: ['/ui/admin/usuarios', '/ui/admin/crearUsuario', '/ui/admin/infoUsuario', '/ui/admin/editarUsuario'] },
    { label: 'Crear usuario', routerLink: '/ui/admin/crearUsuario', secciones: ['/ui/admin/crearUsuario'] },
    { label: 'Detalle usuario', routerLink: '/ui/admin/infoUsuario', secciones: ['/ui/admin/infoUsuario'] },
    { label: 'Editar usuario', routerLink: '/ui/admin/editarUsuario', secciones: ['/ui/admin/editarUsuario'] },
    { label: 'Perfiles', routerLink: '/ui/admin/perfiles', secciones: ['/ui/admin/perfiles', '/ui/admin/crearPerfil', '/ui/admin/infoPerfil', '/ui/admin/editarPerfil'] },
    { label: 'Crear perfil', routerLink: '/ui/admin/crearPerfil', secciones: ['/ui/admin/crearPerfil'] },
    { label: 'Detalle perfil', routerLink: '/ui/admin/infoPerfil', secciones: ['/ui/admin/infoPerfil'] },
    { label: 'Editar perfil`', routerLink: '/ui/admin/editarPerfil', secciones: ['/ui/admin/editarPerfil'] },
    { label: 'Parámetros', routerLink: '/ui/admin/parametros', secciones: ['/ui/admin/parametros'] },
    { label: 'Tipos y subtipos', routerLink: '/ui/admin/producto/tipos', secciones: ['/ui/admin/producto/tipos', '/ui/admin/producto/tipos/afectadas'] },
    { label: 'Presentaciones afectadas', routerLink: '/ui/admin/producto/tipos/afectadas', secciones: ['/ui/admin/producto/tipos/afectadas'] },
    { label: 'Listado de sabores', routerLink: '/ui/admin/producto/sabores', secciones: ['/ui/admin/producto/sabores', '/ui/admin/producto/sabores/nuevo'] },
    { label: 'Nuevo sabor', routerLink: '/ui/admin/producto/sabores/nuevo', secciones: ['/ui/admin/producto/sabores/nuevo'] },
    { label: 'Empresas', secciones: ['/ui/empresa/perfil', '/ui/admin/empresas', '/ui/admin/empresas/solicitudes', '/ui/admin/empresas/solicitudes/detalle'], disabled: true },
    { label: 'Mi perfil', routerLink: '/ui/empresa/perfil', secciones: ['/ui/empresa/perfil'] },
    { label: 'Listado', routerLink: '/ui/admin/empresas', secciones: ['/ui/admin/empresas'] },
    { label: 'Solicitudes de cambio', routerLink: '/ui/admin/empresas/solicitudes', secciones: ['/ui/admin/empresas/solicitudes', '/ui/admin/empresas/solicitudes/detalle'] },
    { label: 'Detalle solicitud', routerLink: '/ui/admin/empresas/solicitudes/detalle', secciones: ['/ui/admin/empresas/solicitudes/detalle'] },
    { label: 'Healthcheck', routerLink: '/ui/admin/healthcheck', secciones: ['/ui/admin/healthcheck'] },
    { label: 'Mantenimiento', secciones: ['/ui/mantenimiento/productos', '/ui/mantenimiento/detalle-producto'], disabled: true },
    { label: 'Productos', routerLink: '/ui/mantenimiento/productos', secciones: ['/ui/mantenimiento/productos', '/ui/mantenimiento/detalle-producto'] },
    { label: 'Detalle producto', secciones: ['/ui/mantenimiento/detalle-producto'] },
    { label: 'Auditoría', routerLink: '/ui/auditoria/listado', secciones: ['/ui/auditoria/listado'] },
    { label: 'Tramitaciones', routerLink: '/ui/tramitaciones', secciones: ['/ui/tramitaciones'] },
    { label: 'Alertas', routerLink: '/ui/alertas', secciones: ['/ui/alertas'] },
    { label: 'Etiquetado', routerLink: '/ui/etiquetado', secciones: ['/ui/etiquetado'] },
    { label: 'Desarrollador', routerLink: '/ui/desarrollador', secciones: ['/ui/desarrollador'] }
  ];

  //SOLICITUD INCLUSIÓN
  public menuSolicitudInclusion: MenuItem[] = [
    //{ id: '0', label: 'Solicitud de Inclusión',  disabled: false},
    { id: '0', label: 'Requisitos' },
    { id: '1', label: 'Empresa' },
    { id: '2', label: 'Producto',  },
    { id: '3', label: 'Información'},
    { id: '4', label: 'Presentaciones'},
    { id: '5', label: 'Documentación'},
    { id: '6', label: 'Datos de tasas'}
  ];

  public cambioTitularidad: MenuItem[] = [
    //{ id: '0', label: 'Solicitud de Inclusión',  disabled: false},
    { id: '0', label: 'Requisitos', disabled: true},
    { id: '1', label: 'Empresa', disabled: true},
    { id: '2', label: 'Productos',  disabled: true},
    { id: '3', label: 'Datos de tasas',disabled: true},
  ];

  public consultatitularidad: MenuItem[] = [
    //{ id: '0', label: 'Solicitud de Inclusión',  disabled: false},
    { id: '0', label: 'Empresa', disabled: true},
    { id: '1', label: 'Productos',  disabled: true},
    { id: '2', label: 'Datos de tasas',disabled: true},
    { id: '3', label: 'Registro',disabled: true}
  ];

  //SOLICITUD INCLUSIÓN
  public menuConsulta: MenuItem[] = [
    { id: '0', label: 'Empresa', disabled: false},
    { id: '1', label: 'Producto',  disabled: false},
    { id: '2', label: 'Información',  disabled: false},
    { id: '3', label: 'Presentaciones',  disabled: false},
    { id: '4', label: 'Documentación', disabled: false},
    { id: '5', label: 'Datos de tasas',disabled: false},
    { id: '6', label: 'Registro', disabled: false}
  ];

  //SOLICITUD INCLUSIÓN - AESAN - CARTERA
  public menuSolicitudInclusionAESAN: MenuItem[] = [
    { id: '0', label: 'Empresa', routerLink: '/ui/empresa/solicitud/empresa' },
    { id: '1', label: 'Producto', routerLink: '/ui/empresa/solicitud/producto'},
    { id: '2', label: 'Información', routerLink: '/ui/empresa/solicitud/producto-informacion-nutricional' },
    { id: '3', label: 'Presentaciones', routerLink: '/ui/empresa/solicitud/presentaciones' },
    { id: '4', label: 'Documentación', routerLink: '/ui/empresa/solicitud/documentacion'},
    { id: '5', label: 'Datos de tasas', routerLink: '/ui/empresa/solicitud/pagotasas'},
    { id: '6', label: 'Registro', routerLink: '/ui/empresa/solicitud/registro' }
  ];

  //Acciones AESAN
  accionesAESAN: any[] = [
    { id:Accion.OficioFavorable, name: 'Emitir oficio favorable'},
    { id:Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'},
    { id:Accion.ResDefinitivaNegativa, name: 'Resolución definitiva denegatoria'},
    { id:Accion.ReactivarSolicitud, name: 'Reactivar solicitud'},
    { id:Accion.AmpliarSubsanacion,  name: 'Ampliar plazo de subsanación'}
  ];

  accionesAesanConfirmadas: any[] = [

  ];

  accionesAesanDenegadas: any[] = [
    { id: Accion.OficioFavorable, name: 'Emitir oficio favorable'},
    { id: Accion.ResDefinitivaNegativa, name: 'Resolución definitiva denegatoria'},
    { id: Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'},
    { id: Accion.ReactivarSolicitud , name: 'Reactivar'}
  ];

  accionesAesanPendientes: any[] = [
    { id: Accion.OficioFavorable, name: 'Emitir oficio favorable'},
    { id:Accion.PropResolucionDenegatoria, name: 'Propuesta resolución denegatoria'},
    { id: Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'}
  ];

  accionesAesanPropu: any[] = [
    { id: Accion.OficioFavorable, name: 'Emitir oficio favorable'},
    { id: Accion.ResDefinitivaNegativa, name: 'Resolución definitiva denegatoria'},
    { id: Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'}
  ];

  //Acciones Cartera
  accionesCartera: any[] = [
    { id:Accion.ResDefinitivaFavorable, name: 'Resolución definitiva favorable'},
    { id:Accion.CartaIncidencias, name: 'Carta de incidencias'},
    { id:Accion.PropResolucionDenegatoria, name: 'Propuesta resolución denegatoria'},
    { id:Accion.ResDefinitivaNegativa, name: 'Resolución definitiva denegatoria'}
  ];

  accionesCarteraAceptadas: any[] = [
    { id: Accion.RectificacionResFavorable, name: 'Rectificación resolución favorable'}
  ];

  accionesCarteraDenegadas: any[] = [
    { id:Accion.ResDefinitivaFavorable, name: 'Resolución definitiva favorable'},
    { id:Accion.CartaIncidencias, name: 'Carta de incidencias'},
    { id:Accion.ResDefinitivaNegativa, name: 'Resolución definitiva denegatoria'},
    { id:Accion.ReactivarSolicitud , name: 'Reactivar'}
  ];

  accionesCarteraPendientes: any[] = [
    { id: Accion.ResDefinitivaFavorable, name: 'Resolución definitiva favorable'},
    { id:Accion.PropResolucionDenegatoria, name: 'Propuesta resolución denegatoria'},
    { id: Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'},
    { id: Accion.SolicitarSubsanacionAESAN, name: 'Solicitar subsanación AESAN'}
  ];

  accionesCarteraPropu: any[] = [
    { id: Accion.ResDefinitivaFavorable, name: 'Resolución definitiva favorable'},
    { id: Accion.ResDefinitivaDenegatoria, name: 'Resolución definitiva denegatoria'},
    { id: Accion.SolicitarSubsanacionEmpresa, name: 'Solicitar subsanación'},
    { id: Accion.SolicitarSubsanacionAESAN, name: 'Solicitar subsanación AESAN'}
  ];

  accionesCarteraSubsan: any[] = [
    { id:Accion.PropResolucionDenegatoria, name: 'Propuesta resolución denegatoria'}
  ]

  //Acciones que abrirán el modal de adjuntar documento
  accionesPlantillas: string[] = [
    Accion.SolicitarSubsanacionEmpresa,
    Accion.SolicitarSubsanacionAESAN,
    Accion.ResDefinitivaNegativa,
    Accion.OficioFavorable,
    Accion.PropResolucionDenegatoria,
    Accion.ResDefinitivaDenegatoria,
    Accion.RectificacionResFavorable
  ];

  //Acciones que abrirán el modal de adjuntar documento/modificar plantilla
  accionesAdjuntarGenerarModificarPlantilla: string[] = [
    Accion.ResDefinitivaFavorable
  ]

  /**
   * Acciones que se mostrarán en el select de acciones si el usuario es empresa
   */
  accionesEmpresa: any[] = [
    { id:Accion.DesistirSolicitud, name: 'Desistir de la solicitud'}
  ];

  /**
   * Acciones que se mostrarán en el select de acciones si el usuario es empresa y la solicitud está propuesta para una resolución denegatoria
   */
  accionesEmpresaPropu: any[] = [
    { id:Accion.DesistirSolicitud, name: 'Desistir de la solicitud'},
    { id:Accion.PresentarAlegaciones, name: 'Presentar alegaciones'}
  ];

  /**
   * Acciones que se mostrarán en Comercialización para las presentaciones de los productos
   */
  accionesComercializacion = [
    {id: Accion.BajaPresentacion, name: 'Baja'},
    {id: Accion.SuspensionTemporal, name: 'Suspensión Temporal'},
    // {id: Accion.SolicitarProrroga, name: 'Solicitar Prórroga'},
    {id: Accion.Comercializar, name: 'Comercializar'},
    {id: Accion.DesistirPresentacion, name: 'Desistir'}
  ]

  /**
   * Creates an instance of BreadcrumMenuService.
   * 
   * @param {LoginService} loginService
   * @memberof BreadcrumMenuService
   */
  constructor(private loginService:LoginService) {
    //Por compatibilizar la maraña que han creado con la identificación del usuario mantemos el código que había pero lo vinculamos a la información del login.
    loginService.onLoginInfoChanged().subscribe((loginInfo) => {
      if(loginInfo != null){
        console.log("BreadcrumMenuService.onLoginInfoChanged()");
        this._esEmpresa = this.loginService.isEmpresa()!;
        this._esAESAN = this.loginService.isAESAN()!;
        this._esCartera= this.loginService.isCartera()! || this.loginService.isCarteraLectura()!;
      }
    });
  }

  /**
   * getMigaPan
   *
   * @param {string} seccion
   * @return {*}  {*}
   * @memberof BreadcrumMenuService
   */
  public getMigaPan(seccion: string): any {
    return {items: this.migaPan.filter(item => item.secciones.includes(seccion)), home: this.home};
  }

  /**
   * getMenuSolicitudInclusion
   *
   * @return {*}  {MenuItem[]}
   * @memberof BreadcrumMenuService
   */
  public getMenuSolicitudInclusion(): MenuItem[]{
    return this.menuSolicitudInclusion;
  }

  /**
   * getMenuInicializadoSolicitudInclusion
   *
   * @return {*}  {MenuItem[]}
   * @memberof BreadcrumMenuService
   */
  public getMenuInicializadoSolicitudInclusion(): MenuItem[]{
    this.inicializarMenuSolicitudInclusion();
    return this.menuSolicitudInclusion;
  }

  /**
   * inicializarMenuSolicitudInclusion
   *
   * @memberof BreadcrumMenuService
   */
  public inicializarMenuSolicitudInclusion(){
    for(let i = 1; i <= 6; i++){
      this.menuSolicitudInclusion.at(i)!.disabled = false;
      this.menuSolicitudInclusion.at(i)!.styleClass = '';
    }
  }

  /**
   * getMenuSolicitudInclusionAESAN
   *
   * @return {*}  {MenuItem[]}
   * @memberof BreadcrumMenuService
   */
  public getMenuSolicitudInclusionAESAN(): MenuItem[]{
    return this.menuSolicitudInclusionAESAN;
  }

  /**
   * getMenuInicializadoSolicitudInclusionAESAN
   *
   * @return {*}  {MenuItem[]}
   * @memberof BreadcrumMenuService
   */
  public getMenuInicializadoSolicitudInclusionAESAN(): MenuItem[]{
    this.inicializarMenuSolicitudInclusionAESAN();
    return this.menuSolicitudInclusionAESAN;
  }

  /**
   * inicializarMenuSolicitudInclusionAESAN
   *
   * @memberof BreadcrumMenuService
   */
  public inicializarMenuSolicitudInclusionAESAN(){
    for(let i = 1; i <= 6; i++){
      this.menuSolicitudInclusionAESAN.at(i)!.disabled = true;
      this.menuSolicitudInclusionAESAN.at(i)!.styleClass = '';
    }
  }

  /**
   * getMenu
   *
   * @return {*} 
   * @memberof BreadcrumMenuService
   */
  public getMenu() {
    if(this.esAESAN || this.esCartera){
      return this.menuConsulta;
    }else{
      return this.menuSolicitudInclusion;
    }
  }

  /**
   * getMenuConsulta
   *
   * @return {*} 
   * @memberof BreadcrumMenuService
   */
  public getMenuConsulta(){
    return this.menuConsulta;
  }

  /**
   * enbleAllMenu
   *
   * @param {MenuItem[]} menu
   * @return {*} 
   * @memberof BreadcrumMenuService
   */
  enbleAllMenu(menu: MenuItem[]){
    menu.forEach(item => {item.disabled = false});
    return menu;
  }

  /**
   * enableMenu
   *
   * @param {MenuItem[]} menu
   * @param {string} page
   * @return {*} 
   * @memberof BreadcrumMenuService
   */
  enableMenu(menu: MenuItem[], page: string){
    menu.forEach(item => {
      item.disabled = item.id == page;
      item.styleClass = (item.id == page) ? 'subrayado' : undefined;
    });
    return menu;
  }
  
}
